import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { FormControl } from '@angular/forms';
import { switchMap } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { BazisInputOptionsGroupedComponent } from '@bazis/form/components/base/options/input-options-grouped.component';

@Component({
    selector: 'bazis-autocomplete-grouped-data',
    templateUrl: './autocomplete-grouped-data.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisAutocompleteGroupedDataComponent extends BazisInputOptionsGroupedComponent {
    // отображение (только визуально, не меняя логики) в виде списка чекбоксов
    @Input() byCheckbox: boolean = true;

    // дефолтное значение, необходимо для списков сортировки и подобным,
    // когда что-то обязательно должно быть выбрано
    @Input() defaultValueId: string;

    // внешний вид, secondary - серый
    @Input() type: 'default' | 'secondary' = 'default';

    // метка поля, задействованная в теле option
    @Input() optionLabel: string;

    // метка поля, задействованная в теле option
    @Input() placeholderKey: string;

    @Input() searchPlaceholderKey: string;

    @Input() iconUp: string = this.icons.caretUp;

    @Input() iconDown: string = this.icons.caretDown;

    public readonly attrId = `${uuidv4()}`;

    showList = false;

    searchControl = new FormControl(null);

    filteredGroups$ = this.sortedGroups$.pipe(
        switchMap((groups) =>
            this.searchControl.valueChanges.pipe(
                startWith(null),
                map((v) => {
                    const searchString = v?.trim();
                    if (!searchString) return groups;
                    return this.filterGroupsByString([...groups], searchString.toLowerCase());
                }),
            ),
        ),
    );

    filterGroupsByString(groups, searchString) {
        return groups
            .map((group) => {
                return {
                    ...group,
                    groupOptions: group.groupOptions.filter(
                        (option) => option.$snapshot.name.toLowerCase().indexOf(searchString) > -1,
                    ),
                };
            })
            .filter((group) => group.groupOptions.length > 0);
    }

    toggleList() {
        if (this.showList && this.isFocused) return;
        this.showList = !this.showList;
        this.markAsTouched();
    }

    hideList() {
        if (!this.isFocused) this.showList = false;
    }

    toggleValue(id) {
        super.toggleValue(id);
        if (!this.multiple) {
            this.hideList();
            this.searchControl.setValue(null);
        }
    }

    onBlurInput() {
        this.isFocused = false;
    }

    onClear() {
        // из автокомплитного компонента
        this.values._.forEach((val) => {
            this.toggleValue(val);
        });
        this.ngControl.control.setValue(this.emptyValue || (this.multiple ? [] : null));
    }
}
